import { escapeHtml } from './ui.js'
import { hasPermission } from './clientAuth.js'

/**
 * Sidebar portal cliente (dash layout). WAVE-864
 * @param {{ activePath: string, showTwin?: boolean, nav?: { pending_notices?: number, pending_tickets?: number } }} opts
 */
export function portalSideNavHtml({ activePath, showTwin = false, nav = {} }) {
  const pendingNotices = Number(nav.pending_notices) || 0
  const pendingTickets = Number(nav.pending_tickets) || 0
  const showNotices = hasPermission('client_portal.notices.read')
  const showTickets = hasPermission('client_portal.tickets.read') && pendingTickets > 0
  const showDocs = hasPermission('client_portal.signing.read')

  const badge = (n) =>
    n > 0 ? `<span class="dash-nav-badge" aria-label="${n} pendientes">${n > 99 ? '99+' : n}</span>` : ''

  const link = (href, label, active, extra = '') => {
    const cls = active ? ' class="is-active" aria-current="page"' : ''
    return `<a href="${href}" data-link${cls}>${escapeHtml(label)}${extra}</a>`
  }

  let html = link('/mi-instalacion', 'Resumen', activePath === '/mi-instalacion')
  if (showNotices) {
    html += link(
      '/mi-instalacion/avisos',
      'Avisos',
      activePath === '/mi-instalacion/avisos',
      badge(pendingNotices)
    )
  }
  if (showTickets) {
    html += link(
      '/mi-instalacion/tickets',
      'Tickets',
      activePath === '/mi-instalacion/tickets',
      badge(pendingTickets)
    )
  }
  if (showDocs) {
    html += link('/mi-instalacion/documentos', 'Documentos', activePath.startsWith('/mi-instalacion/documentos'))
  }
  html += link('/mi-instalacion/nueva-incidencia', 'Nueva incidencia', activePath === '/mi-instalacion/nueva-incidencia')
  html += link('/mi-instalacion/presupuesto-it', 'Solicitar presupuesto', activePath === '/mi-instalacion/presupuesto-it')
  if (showTwin) {
    html += `<a href="/mi-instalacion/gemelo" data-link id="dash-twin-btn"${activePath === '/mi-instalacion/gemelo' ? ' class="is-active" aria-current="page"' : ''}>Gemelo 3D</a>`
  } else {
    html += `<a href="/mi-instalacion/gemelo" data-link id="dash-twin-btn" hidden>Gemelo 3D</a>`
  }
  html += link('/ia', 'Asistente IA', activePath === '/ia')

  return html
}

export function updatePortalSideNavBadges(root, nav = {}) {
  const noticesLink = root.querySelector('a[href="/mi-instalacion/avisos"]')
  if (noticesLink) {
    noticesLink.querySelector('.dash-nav-badge')?.remove()
    const n = Number(nav.pending_notices) || 0
    if (n > 0) {
      noticesLink.insertAdjacentHTML(
        'beforeend',
        `<span class="dash-nav-badge" aria-label="${n} pendientes">${n > 99 ? '99+' : n}</span>`
      )
    }
  }
  const ticketsNav = root.querySelector('a[href="/mi-instalacion/tickets"]')
  const nTickets = Number(nav.pending_tickets) || 0
  if (nTickets > 0 && hasPermission('client_portal.tickets.read')) {
    if (!ticketsNav) {
      const avisos = root.querySelector('a[href="/mi-instalacion/avisos"]')
      const docs = root.querySelector('a[href="/mi-instalacion/documentos"]')
      const anchor = avisos || docs
      if (anchor) {
        anchor.insertAdjacentHTML(
          'afterend',
          `<a href="/mi-instalacion/tickets" data-link>Tickets<span class="dash-nav-badge">${nTickets > 99 ? '99+' : nTickets}</span></a>`
        )
      }
    } else {
      ticketsNav.hidden = false
      ticketsNav.querySelector('.dash-nav-badge')?.remove()
      ticketsNav.insertAdjacentHTML(
        'beforeend',
        `<span class="dash-nav-badge">${nTickets > 99 ? '99+' : nTickets}</span>`
      )
    }
  } else if (ticketsNav) {
    ticketsNav.remove()
  }
}

export function wirePortalSideLogout(root, { navigate, onLogout }) {
  root.querySelector('#dash-logout')?.addEventListener('click', onLogout)
  root.querySelector('#pending-logout')?.addEventListener('click', onLogout)
}
